import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../redux/root-reducer';

export const getSeriesCartTotal = (state: RootState) =>
  state.seriesCart.seriesCartTotal;

export const getSeriesSelectedTicketOrderSummary = createSelector(
  (state: RootState) => state.seriesCart.selectedTicketOrderSummary,
  selectedTicketOrderSummary => selectedTicketOrderSummary,
);

export const getTicketOrderSummaryByEventExternalId = createSelector(
  [
    (state: RootState) => state.seriesCart.selectedTicketOrderSummary,
    (_state: RootState, eventExternalId: string) => eventExternalId,
  ],
  (selectedTicketOrderSummary, eventExternalId) =>
    selectedTicketOrderSummary[eventExternalId],
);

export const isSeriesOrderSummaryLoading = createSelector(
  (state: RootState) => state.seriesCart.loadingOrderSummary,
  loading => loading,
);

export const getSeriesOrderSummaryError = createSelector(
  (state: RootState) => state.seriesCart.error,
  error => error,
);

export const isProcessingCheckout = createSelector(
  (state: RootState) => state.seriesCart.paymentStatus,
  paymentStatus => paymentStatus === 'pending',
);

export const isPaymentRequired = createSelector(
  (state: RootState) => state.seriesCart,
  seriesCart => seriesCart.seriesCartTotal > 0,
);

export const isPaymentSuccessSelector = createSelector(
  (state: RootState) => state.seriesCart.paymentStatus,
  paymentStatus => paymentStatus === 'success',
);

export const getSeriesPromoCode = (state: RootState) =>
  state.seriesCart.promoCode.code;

export const getSeriesPromoCodeState = (state: RootState) =>
  state.seriesCart.promoCode;
